import { render } from "./NovapostCredentialFields.vue?vue&type=template&id=2c36919e"
import script from "./NovapostCredentialFields.vue?vue&type=script&lang=js"
export * from "./NovapostCredentialFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__